import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

import { getCropFields } from '../../../registration/store/selectors/crop-field.selectors';
import { SoilAnalysisSortHelper } from '../../helpers/SoilAnalysisSortHelper';
import { SoilAnalysis } from '../../models/soil-analysis.model';
import * as SoilAnalysisActions from '../../store/soil-analysis.actions';
import { selectSoilAnalyses, selectSoilAnalysisLoading } from '../../store/soil-analysis.selectors';

@Component({
  selector: 'app-soil-analysis-list',
  standalone: false,
  templateUrl: './soil-analysis-list.component.html',
  styleUrl: './soil-analysis-list.component.scss',
})
export class SoilAnalysisListComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);

  soilAnalyses$ = this.store.pipe(select(selectSoilAnalyses));
  soilAnalyses: SoilAnalysis[] = [];
  cropFields$ = this.store.pipe(select(getCropFields));
  isLoading$ = this.store.pipe(select(selectSoilAnalysisLoading));
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  ngOnInit() {
    this.soilAnalyses$.pipe(takeUntil(this.destroyed$)).subscribe((soilAnalyses) => {
      this.soilAnalyses = SoilAnalysisSortHelper.sortDesc(soilAnalyses);
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  selectSoilAnalysis(soilAnalysis: SoilAnalysis) {
    this.store.dispatch(SoilAnalysisActions.selectSoilAnalysis({ soilAnalysis }));
  }

  showCoordinateWarning(soilAnalysis: SoilAnalysis): boolean {
    const isEurofins = soilAnalysis.labId?.toLowerCase() === 'eurofins';
    if (soilAnalysis.isManualEntry || !isEurofins) {
      return false;
    }

    return !soilAnalysis.borderData;
  }

  isLinkedCropFieldEmpty(soilAnalysis: SoilAnalysis) {
    let isLinkedEmpty = false;
    this.cropFields$.subscribe((cropFields) => {
      isLinkedEmpty = !cropFields.some((cropField) =>
        cropField.soilAnalysisIds.includes(soilAnalysis.id),
      );
    });

    return isLinkedEmpty;
  }
}
